/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminSubscriberBenefit,
  AdminV1OrganizationsPaymentsBenefitsListParams,
  AdminV1OrganizationsPaymentsOfferingsBenefitsListParams,
  AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsListParams,
  BenefitChangePreviewRequest,
  BenefitChangePreviewResponse,
  MembershipBenefit,
  PaginatedAdminSubscriberBenefitList,
  PaginatedMembershipBenefitList,
  PatchedAdminSubscriberBenefit,
  PatchedMembershipBenefit
} from '.././model';

import adminV1OrganizationsPaymentsBenefitsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsBenefitsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsBenefitsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsBenefitsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsBenefitsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsBenefitsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsBenefitsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsBenefitsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsBenefitsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsBenefitsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsBenefitsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsBenefitsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsOfferingsBenefitsPreviewChangesCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsDestroyMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * List all subscriber benefits in the organization, optionally filtered by membership.
 * @summary List subscriber benefits
 */
export const adminV1OrganizationsPaymentsBenefitsList = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsBenefitsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBenefitsListMutator<PaginatedAdminSubscriberBenefitList>>,) => {
      return adminV1OrganizationsPaymentsBenefitsListMutator<PaginatedAdminSubscriberBenefitList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/benefits/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Create a new benefit for a specific subscriber/membership.
 * @summary Create a subscriber benefit
 */
export const adminV1OrganizationsPaymentsBenefitsCreate = (
    organizationId: number,
    adminSubscriberBenefit: NonReadonly<AdminSubscriberBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBenefitsCreateMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsBenefitsCreateMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/benefits/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminSubscriberBenefit
    },
      options);
    }
  /**
 * Admin ViewSet for managing individual subscriber benefits.
 * @summary Retrieve a subscriber benefit
 */
export const adminV1OrganizationsPaymentsBenefitsRetrieve = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBenefitsRetrieveMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsBenefitsRetrieveMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/benefits/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Update an existing subscriber benefit (use with caution - may affect user experience).
 * @summary Update a subscriber benefit
 */
export const adminV1OrganizationsPaymentsBenefitsUpdate = (
    organizationId: number,
    id: string,
    adminSubscriberBenefit: NonReadonly<AdminSubscriberBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBenefitsUpdateMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsBenefitsUpdateMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/benefits/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminSubscriberBenefit
    },
      options);
    }
  /**
 * Admin ViewSet for managing individual subscriber benefits.
 * @summary Partially update a subscriber benefit
 */
export const adminV1OrganizationsPaymentsBenefitsPartialUpdate = (
    organizationId: number,
    id: string,
    patchedAdminSubscriberBenefit: NonReadonly<PatchedAdminSubscriberBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBenefitsPartialUpdateMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsBenefitsPartialUpdateMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/benefits/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminSubscriberBenefit
    },
      options);
    }
  /**
 * Permanently delete a subscriber benefit. This should be used carefully as it affects user benefits.
 * @summary Delete a subscriber benefit
 */
export const adminV1OrganizationsPaymentsBenefitsDestroy = (
    organizationId: number,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsBenefitsDestroyMutator<void>>,) => {
      return adminV1OrganizationsPaymentsBenefitsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/benefits/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Retrieve all active benefit templates associated with a specific membership offering.
 * @summary List benefits for an offering
 */
export const adminV1OrganizationsPaymentsOfferingsBenefitsList = (
    organizationId: number,
    offeringPk: string,
    params?: AdminV1OrganizationsPaymentsOfferingsBenefitsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsBenefitsListMutator<PaginatedMembershipBenefitList>>,) => {
      return adminV1OrganizationsPaymentsOfferingsBenefitsListMutator<PaginatedMembershipBenefitList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${offeringPk}/benefits/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Create a new benefit template for a membership offering.
 * @summary Create a new benefit template
 */
export const adminV1OrganizationsPaymentsOfferingsBenefitsCreate = (
    organizationId: number,
    offeringPk: string,
    membershipBenefit: NonReadonly<MembershipBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsBenefitsCreateMutator<MembershipBenefit>>,) => {
      return adminV1OrganizationsPaymentsOfferingsBenefitsCreateMutator<MembershipBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${offeringPk}/benefits/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: membershipBenefit
    },
      options);
    }
  /**
 * Admin ViewSet for managing benefit templates on offerings.
 * @summary Retrieve a benefit template
 */
export const adminV1OrganizationsPaymentsOfferingsBenefitsRetrieve = (
    organizationId: number,
    offeringPk: string,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsBenefitsRetrieveMutator<MembershipBenefit>>,) => {
      return adminV1OrganizationsPaymentsOfferingsBenefitsRetrieveMutator<MembershipBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${offeringPk}/benefits/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Admin ViewSet for managing benefit templates on offerings.
 * @summary Update a benefit template
 */
export const adminV1OrganizationsPaymentsOfferingsBenefitsUpdate = (
    organizationId: number,
    offeringPk: string,
    id: string,
    membershipBenefit: NonReadonly<MembershipBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsBenefitsUpdateMutator<MembershipBenefit>>,) => {
      return adminV1OrganizationsPaymentsOfferingsBenefitsUpdateMutator<MembershipBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${offeringPk}/benefits/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: membershipBenefit
    },
      options);
    }
  /**
 * Admin ViewSet for managing benefit templates on offerings.
 * @summary Partially update a benefit template
 */
export const adminV1OrganizationsPaymentsOfferingsBenefitsPartialUpdate = (
    organizationId: number,
    offeringPk: string,
    id: string,
    patchedMembershipBenefit: NonReadonly<PatchedMembershipBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsBenefitsPartialUpdateMutator<MembershipBenefit>>,) => {
      return adminV1OrganizationsPaymentsOfferingsBenefitsPartialUpdateMutator<MembershipBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${offeringPk}/benefits/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedMembershipBenefit
    },
      options);
    }
  /**
 * Archive (soft delete) a benefit template. This will not affect existing subscriber benefits.
 * @summary Archive a benefit template
 */
export const adminV1OrganizationsPaymentsOfferingsBenefitsDestroy = (
    organizationId: number,
    offeringPk: string,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsBenefitsDestroyMutator<void>>,) => {
      return adminV1OrganizationsPaymentsOfferingsBenefitsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${offeringPk}/benefits/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Preview the impact of benefit changes before saving. Returns count of affected subscribers, change summary, and next billing cycle dates. Use this to show admins what will happen when they modify benefits on an offering.
 * @summary Preview benefit changes
 */
export const adminV1OrganizationsPaymentsOfferingsBenefitsPreviewChangesCreate = (
    organizationId: number,
    offeringPk: string,
    benefitChangePreviewRequest: BenefitChangePreviewRequest,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsOfferingsBenefitsPreviewChangesCreateMutator<BenefitChangePreviewResponse>>,) => {
      return adminV1OrganizationsPaymentsOfferingsBenefitsPreviewChangesCreateMutator<BenefitChangePreviewResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/offerings/${offeringPk}/benefits/preview-changes/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: benefitChangePreviewRequest
    },
      options);
    }
  /**
 * List all subscriber benefits in the organization, optionally filtered by membership.
 * @summary List subscriber benefits
 */
export const adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsList = (
    organizationId: number,
    membershipPk: string,
    params?: AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsListMutator<PaginatedAdminSubscriberBenefitList>>,) => {
      return adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsListMutator<PaginatedAdminSubscriberBenefitList>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/subscriber-memberships/${membershipPk}/benefits/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Create a new benefit for a specific subscriber/membership.
 * @summary Create a subscriber benefit
 */
export const adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsCreate = (
    organizationId: number,
    membershipPk: string,
    adminSubscriberBenefit: NonReadonly<AdminSubscriberBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsCreateMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsCreateMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/subscriber-memberships/${membershipPk}/benefits/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminSubscriberBenefit
    },
      options);
    }
  /**
 * Admin ViewSet for managing individual subscriber benefits.
 * @summary Retrieve a subscriber benefit
 */
export const adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsRetrieve = (
    organizationId: number,
    membershipPk: string,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsRetrieveMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsRetrieveMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/subscriber-memberships/${membershipPk}/benefits/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Update an existing subscriber benefit (use with caution - may affect user experience).
 * @summary Update a subscriber benefit
 */
export const adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsUpdate = (
    organizationId: number,
    membershipPk: string,
    id: string,
    adminSubscriberBenefit: NonReadonly<AdminSubscriberBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsUpdateMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsUpdateMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/subscriber-memberships/${membershipPk}/benefits/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminSubscriberBenefit
    },
      options);
    }
  /**
 * Admin ViewSet for managing individual subscriber benefits.
 * @summary Partially update a subscriber benefit
 */
export const adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsPartialUpdate = (
    organizationId: number,
    membershipPk: string,
    id: string,
    patchedAdminSubscriberBenefit: NonReadonly<PatchedAdminSubscriberBenefit>,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsPartialUpdateMutator<AdminSubscriberBenefit>>,) => {
      return adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsPartialUpdateMutator<AdminSubscriberBenefit>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/subscriber-memberships/${membershipPk}/benefits/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminSubscriberBenefit
    },
      options);
    }
  /**
 * Permanently delete a subscriber benefit. This should be used carefully as it affects user benefits.
 * @summary Delete a subscriber benefit
 */
export const adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsDestroy = (
    organizationId: number,
    membershipPk: string,
    id: string,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsDestroyMutator<void>>,) => {
      return adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/subscriber-memberships/${membershipPk}/benefits/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsBenefitsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBenefitsList>>>
export type AdminV1OrganizationsPaymentsBenefitsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBenefitsCreate>>>
export type AdminV1OrganizationsPaymentsBenefitsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBenefitsRetrieve>>>
export type AdminV1OrganizationsPaymentsBenefitsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBenefitsUpdate>>>
export type AdminV1OrganizationsPaymentsBenefitsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBenefitsPartialUpdate>>>
export type AdminV1OrganizationsPaymentsBenefitsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsBenefitsDestroy>>>
export type AdminV1OrganizationsPaymentsOfferingsBenefitsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsBenefitsList>>>
export type AdminV1OrganizationsPaymentsOfferingsBenefitsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsBenefitsCreate>>>
export type AdminV1OrganizationsPaymentsOfferingsBenefitsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsBenefitsRetrieve>>>
export type AdminV1OrganizationsPaymentsOfferingsBenefitsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsBenefitsUpdate>>>
export type AdminV1OrganizationsPaymentsOfferingsBenefitsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsBenefitsPartialUpdate>>>
export type AdminV1OrganizationsPaymentsOfferingsBenefitsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsBenefitsDestroy>>>
export type AdminV1OrganizationsPaymentsOfferingsBenefitsPreviewChangesCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsOfferingsBenefitsPreviewChangesCreate>>>
export type AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsList>>>
export type AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsCreate>>>
export type AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsRetrieve>>>
export type AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsUpdate>>>
export type AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsPartialUpdate>>>
export type AdminV1OrganizationsPaymentsSubscriberMembershipsBenefitsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsSubscriberMembershipsBenefitsDestroy>>>
